module.exports = __webpack_public_path__ + "images/emoji/lock_with_ink_pen.9dfa78927b3c296b64fa.png";